<template>
  <div class="col-xs-12 pl-25 pr-25 general_notifications_wrapper">
    <div class="col-xs-12 p-0">
      <div
        class="no-notifications"
        v-if="Object.keys(notificationListByDate).length == 0 && !loaderStatus"
      >
        {{ $t('notificationEmptyStateMessage')}}
      </div>
      <div class="col-xs-12 p-0 alert-list">
        <div
          :key="index"
          v-for="(notifications, key, index) in notificationListByDate"
        >
          <!-- <div class="human_readable_date">
            <div v-if="key === today()">Today</div>
            <div v-else-if="key === yesterday()">Yesterday</div>
          </div> -->
          <div
            id="clear_box_shadow"
            class="notification_box row"
            :key="index"
            v-for="(notification, index) in notifications"
            :class="index!==0&&index%2!==0?'notifications_table':''"
          >
            <!-- Title section -->
            <div class="col-xs-12 p-0" v-if="notification.type == 'GN'">
              <!-- <div class="col-xs-12 d-flex mb-20 pl-0">
                <div class="icon_box">
                  <img
                    v-if="
                      notification.notificationType == 'welcome' ||
                        notification.notificationType == 'mail'
                    "
                    src="/static/images/icons/profile_icon.svg"
                    alt
                  />
                </div>
                <div class="pl-15 word-break title-alert">
                  {{ notification.title }}
                </div>
              </div> -->
              <div class="col-xs-12 p-0 notification-content word-break">
                 <div class="col-xs-9 p-0 gen_notification_message">
                  <img src="/static/images/icons/new_notification.svg" class="general-notification-icon"/>
                  <span class="pl-15 notification_message">{{ notification.notification_message }}</span>
                </div>
                <div class="col-xs-3 p-0">
                  <span class="col-xs-12 pl-0 notification_date pr-0">{{ date(key) }}</span>
                </div>
              </div>
            </div>
            <div v-else @click="redirect(notification.type)" class="cursor-pointer">
              <div
                class="col-xs-12 d-flex mb-20 pl-0"
              >
                <div class="icon_box">
                  <img
                    v-if="notification.type == 'PC'"
                    src="/static/images/icons/prod_classification_blue.svg"
                    alt
                  />
                  <img
                    v-else-if="notification.type == 'RP'"
                    src="/static/images/icons/reg_pathway_blue.svg"
                    alt
                  />
                </div>
                <div class="pl-15 word-break title-alert">
                  {{ notification.header }}
                </div>
              </div>
              <div class="col-xs-12 notification-content word-break">
              <div class="col-xs-12 font-medium mb-15">
                Date: <span class="font-300">{{ date(key) }}</span>
              </div>
              <div class="col-xs-12 font-300">
                {{ notification.description }}
              </div>
            </div>
            </div>
            <!-- <div style="cursor:pointer" class="col-md-12 padding-reset registration" v-if="notification.type == 'GN'">
              <div class="row mr_bt_5" v-if="notification.notificationType =='welcome' || notification.notificationType =='mail'">
                <div class="col-md-1 col-xs-2 col-sm-2 icon_box">
                  <img
                    src="/static/images/icons/profile_icon.svg"
                    alt
                  />
                </div>
                <div class="title-alert col-xs-8 col-sm-10 pd_lt_0 col-md-10">{{notification.title}}</div>
              </div>
              <div class="row mr_bt_5" v-else>
                <div class="title-alert col-md-offset-1 col-xs-offset-2 col-xs-8 col-sm-10 pd_lt_0 col-md-10">{{notification.title}}</div>
              </div>
              <div class="row mr_bt_10">
                <div class="col-md-10 pd_lt_0 col-sm-10 col-sm-offset-2 col-md-offset-1">
                  <div class="description-alert hidden-xs">{{notification.notification_message}}</div>
                </div>
              </div>
            </div>
            <div v-else class="col-md-12 padding-reset registration cursor" @click="redirect(notification.type)">
              <div class="row mr_bt_5">
                <div class="col-md-1 col-xs-2 col-sm-2 icon_box">
                  <img v-if="notification.type == 'PC'" src="/static/images/icons/prod_classification_blue.svg" alt />
                  <img v-else-if="notification.type == 'RP'" src="/static/images/icons/reg_pathway_blue.svg" alt />
                </div>
                <div class="title-alert col-xs-8 col-sm-10 pd_lt_0 col-md-10">{{notification.header}}</div>
              </div>
              <div class="row mr_bt_10">
                <div class="col-md-offset-1 col-xs-offset-2 col-xs-8 col-sm-10 pd_lt_0 col-md-10 description-alert hidden-xs">{{notification.description}}
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import * as moment from 'moment';
import Loader from '../UIComponents/Loader.vue';
import EventBus from '../../utils/event-bus';
import {
  getUserGeneralNotificationsAlert,
  getUserNewNotificationsCount,
} from '../../apis/notification';

export default {
  components: {
    Loader,
  },
  props: ['startDate', 'endDate', 'notificationsStarMarkCount'],
  data() {
    return {
      notificationListByDate: {},
      generalNotifications: '',
      newAlertsCount: 0,
      newNotificationCount: 0,
      loaderStatus: false,
      notificationTypes: [
        'added',
        'deleted',
        'modified',
        'expired',
        'expiring',
        'welcome',
        'active',
        'mail',
        'pending',
      ],
    };
  },
  methods: {
    async getNewNotificationsCount() {
      // To update star mark on tab level for General Notifications
      const response = await getUserNewNotificationsCount();
      EventBus.$emit('userNewNotificationsCount', response);
    },
    redirect(type) {
      if (type === 'PC') {
        this.$router.push('/layout/prodclassification');
      } else if (type === 'RP') {
        this.$router.push('/layout/regulatory-pathway');
      }
    },
    date(date) {
      if (date === 'N/A') {
        return this.$i18n.locale === 'Portuguese' ? 'N/D' : date;
      }
      const formattedDate = this.$i18n.locale === 'Portuguese' ? moment(date).format('DD/MM/YYYY') : moment(date).format('MM/DD/YYYY');
      return formattedDate;
    },
    today() {
      return moment().format('YYYY-MM-DD');
    },
    yesterday() {
      return moment()
        .add(-1, 'days')
        .format('YYYY-MM-DD');
    },
    async getUserGeneralNotificationsAlert() {
      this.newAlertsCount = 0;
      this.newNotificationCount = 0;
      this.loaderStatus = true;
      this.notificationListByDate = {};
      const startAlertDate = moment(this.startDate).format('YYYY-MM-DD');
      const endAlertDate = moment(this.endDate).format('YYYY-MM-DD');
      const alertDateObj = {
        startAlertDate,
        endAlertDate,
      };
      if (alertDateObj.startAlertDate === 'Invalid date' || alertDateObj.endAlertDate === 'Invalid date') {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
            this.$i18n.locale === 'Portuguese'
              ? 'Tanto a data de início quanto a data de fim são obrigatórias'
              : 'Both Start date and End date are mandatory',
          group: 'custom-notification'
        });
        this.loaderStatus = false;
        return;
      }
      const response = await getUserGeneralNotificationsAlert(alertDateObj);
      EventBus.$emit('generalNotificationsCount', response.length);

      response.forEach((data) => {
        if (data.type === 'GN') {
          // General
          if (
            Object.keys(this.notificationListByDate).indexOf(
              moment.utc(data.creation_date).format('YYYY-MM-DD'),
            ) === -1
          ) {
            this.notificationListByDate[
              moment.utc(data.creation_date).format('YYYY-MM-DD')
            ] = [];
            this.notificationListByDate[
              moment.utc(data.creation_date).format('YYYY-MM-DD')
            ].push({
              is_seen: data.is_seen,
              notification_message: data.notification_message,
              title: data.title,
              alertId: data.refrence_id,
              registrationId: data.registration_id,
              notificationType: this.filterNotificationType(data.title),
              type: data.type,
            });
          } else {
            this.notificationListByDate[
              moment.utc(data.creation_date).format('YYYY-MM-DD')
            ].push({
              is_seen: data.is_seen,
              notification_message: data.notification_message,
              title: data.title,
              alertId: data.refrence_id,
              registrationId: data.registration_id,
              notificationType: this.filterNotificationType(data.title),
              type: data.type,
            });
          }
        } else if (
          Object.keys(this.notificationListByDate).indexOf(
            moment.utc(data.creation_date).format('YYYY-MM-DD'),
          ) === -1
        ) {
          // Apart from General
          this.notificationListByDate[
            moment.utc(data.creation_date).format('YYYY-MM-DD')
          ] = [];
          this.notificationListByDate[
            moment.utc(data.creation_date).format('YYYY-MM-DD')
          ].push({
            is_seen: data.notification_status,
            type: data.type,
            header: data.header,
            description: data.description,
          });
        } else {
          this.notificationListByDate[
            moment.utc(data.creation_date).format('YYYY-MM-DD')
          ].push({
            is_seen: data.notification_status,
            type: data.type,
            header: data.header,
            description: data.description,
          });
        }
      });
      // this.notificationListByDate =
      this.loaderStatus = false;
    },
    filterNotificationType(title) {
      const titleArray = title.split(' ');
      const that = this;
      const notificationType = titleArray.find((titleVal) => that.notificationTypes.find(
        (type) => type.toLowerCase() === titleVal.toLowerCase(),
      ));
      return typeof notificationType !== 'undefined'
        ? notificationType.toLowerCase()
        : '';
    },
  },
  watch: {
    startDate() {
      if (this.startDate !== null && this.startDate !== '' && this.endDate !== null && this.endDate !== '') {
        this.getUserGeneralNotificationsAlert();
      }
    },
    endDate() {
      if (this.endDate !== null && this.endDate !== '' && this.startDate !== null && this.startDate !== '') {
        this.getUserGeneralNotificationsAlert();
      }
    },
  },
  async created() {
    this.getUserGeneralNotificationsAlert();
    if (this.notificationsStarMarkCount.general_notifications_count > 0) {
      setTimeout(() => {
        this.getNewNotificationsCount();
      }, 500);
    }
  },
  mounted() {
    EventBus.$on('loadActiveNotificationTab', async () => {
      this.getUserGeneralNotificationsAlert();
      if (this.notificationsStarMarkCount.general_notifications_count > 0) {
        setTimeout(() => {
          this.getNewNotificationsCount();
        }, 500);
      }
    });
  },
  beforeDestroy() {
    EventBus.$off('loadActiveNotificationTab');
  },
};
</script>
<style scoped src="../../../public/static/css/notification-widget.css"></style>
<style scoped>
.notifications_table {
  background-color: #F5F5F5 !important;
  height: 52px;
}
.general_notifications_wrapper {
  height: 100vh;
  background: #EBEBEB;
}
.notification_message {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #01518A;
  padding-left: 16px;
}
.general-notification-icon {
  width: 24px;
  height: 24px;
}
.pl-60{
  padding-left: 60px;
}
.gen_notification_message{
  font-weight: 300;
  font-size: 18px;
  line-height: 25px;
  color: #000000;
  display: inline-flex;
}
.gen_notification_date{
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  color: #333333;
  padding-top: 8px;
  padding-right: 30px;
}
.notification_date {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: right;
  color: #3E3E3E;
  padding-right: 17px;
}
.no-notifications {
  font-weight: 300;
  font-size: 18px;
  line-height: 25px;
  color: #000000;
}
img {
  width: 28px;
  height: 28px;
}
.notification_box {
  margin: 0px;
  padding: 0px;
  border-bottom: none;
  background-color: #FAFAFA;
}
.notification-content{
  padding: 0px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 14px;
}

#clear_box_shadow {
  box-shadow: none;
  border-radius: 0;
}
</style>
